import { Injectable } from '@angular/core';

import { objectToQueryString } from '../../common/utils';
import { sortByLocalName } from '../../common/utils/local-sort';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

@Injectable()
export class LocalService {
  constructor(private readonly rest: RestService) {}

  getLocals(search: string = ''): Promise<any> {
    const query = objectToQueryString({
      search,
    });

    // Every local dropdown loads through here, so sort once: numeric locals first, then names A-Z.
    return this.rest.get(`${environment.apiUrl}/api/core/local${query}`).then((res) => {
      if (res && Array.isArray(res.data)) {
        res.data = sortByLocalName(res.data);
      }

      return res;
    });
  }

  getLocalById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/local/${id}`);
  }

  createLocal(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/local`, payload);
  }

  updateLocal(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/local/${id}`, payload);
  }

  deleteLocal(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/local/${id}`);
  }
}
